import styled from "@emotion/styled";

import { Flex } from "metabase/ui";

export const FilterHeaderRoot = styled(Flex)`
  border-bottom: 1px solid var(--mb-color-border);
`;
